import I18n from "common/i18n";
import { btnDelay, usePlaySound } from "common/utils";

export const TrashMapsHeader = ({
  count,
  onToggleSort,
}: {
  count: number;
  onToggleSort: () => void;
}) => {
  const play = usePlaySound();

  const handleToggleSort = () => {
    play();
    btnDelay(() => onToggleSort());
  };

  return (
    <div className="flex-row-el items-center justify-between w-full px-2 py-2 shrink-0 gap-2">
      <div className="flex-row-el items-center gap-1 bg-brown-80 rounded-full px-3 py-1 shadow-sm shrink-0">
        <span className="material-symbols-outlined text-white type-sm">delete</span>
        <p className="type-text type-sm text-white whitespace-nowrap">
          {I18n.t("MSG_BUILDER_TRASH_COUNT", { count })}
        </p>
      </div>

      <div className="flex-row-el items-center gap-1 bg-white/70 rounded-2xl px-3 py-1 border-dashed border-2 border-brown-80">
        <span className="material-symbols-outlined text-danger type-sm">schedule</span>
        <p className="type-text type-sm text-textcolor-black whitespace-nowrap">
          {I18n.t("MSG_BUILDER_TRASH_NOTICE")}
        </p>
      </div>

      <div className="flex-row-el items-center upsilon shrink-0">
        <button type="button" onClick={handleToggleSort} className="type-inherit-font btn btn-blue">
          <div className="flex-row-center gap-1">
            <span className="material-symbols-outlined text-white type-sm">swap_vert</span>
            <p className="type-text type-sm text-white whitespace-nowrap">
              {I18n.t("MSG_BUILDER_TRASH_SORT")}
            </p>
          </div>
        </button>
      </div>
    </div>
  );
};
